/**
 * Formats a phone number by adding spaces: XXX XXXX XXXXX...
 * Removes existing spaces and applies consistent formatting.
 * 
 * @param {string} phoneNumber - Phone number to format (with or without spaces)
 * @returns {string} Formatted phone number (e.g., "080 1234 5678")
 * 
 * @example
 * formatPhoneNumber('08012345678') // '080 1234 5678'
 * formatPhoneNumber('0801234')     // '080 1234'
 */
export const formatPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\s/g, '')
  if (cleaned.length >= 11) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 7)} ${cleaned.slice(7)}`
  } else if (cleaned.length >= 7) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 7)} ${cleaned.slice(7)}`
  } else if (cleaned.length >= 3) {
    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`
  }
  return cleaned
}